import { render, staticRenderFns } from "./QuoteReplicaDetail.vue?vue&type=template&id=c52e1310&scoped=true"
import script from "./QuoteReplicaDetail.vue?vue&type=script&lang=js"
export * from "./QuoteReplicaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52e1310",
  null
  
)

export default component.exports